<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Affiliate performance report</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Affiliate performance report</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <div class="btn-toolbar pull-right">
              <a
                href="javascript:void(0)"
                class="btn btn-info"
                @click="show_filter = !show_filter"
              ><i class="fa fa-filter"></i>Filter</a
              >
            </div>

            <div class="card-tools">
              <button class="btn btn-info" @click="exportReport()">
                <i class="fas fa-download"></i> Export
              </button>
            </div>
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="show_filter">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="username"
                    >Username</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="username"
                        class="form-control"
                        v-model="filter.username"
                        placeholder="Username"
                      />
                    </div>
                  </div>
                </div>
                <!--<div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="created_at"
                    >Date range</label
                    >
                    <div class="col-md-9">
                      <date-picker
                        type="datetime"
                        input-class="form-control"
                        v-model="filter.created_at"
                        range
                        lang="en"
                        format="YYYY-MM-DD hh:mm:ss"
                        confirm
                        id="created_at"
                        value-type="YYYY-MM-DD hh:mm:ss"
                      ></date-picker>
                    </div>
                  </div>
                </div>-->
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common m-2px">
                        Search
                      </button>
                      <button
                        type="reset"
                        class="btn btn-warning"
                        @click="resetFilter()"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
              <tr>
<!--                <th style="width: 10px">ID</th>-->
                <th>Registered username</th>
                <th>Registered name </th>
                <th>No. of clicks <sort-icons :_sort="'ref_click_log_count'"/></th>
                <th>Sales amount(Tk) <sort-icons :_sort="'total_order_price'"/></th>
                <th>Earned points <sort-icons :_sort="'total_earned_points'"/></th>
                <th>Last sale at <sort-icons :_sort="'updated_at'"/></th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(student, index) in students.data">
                <!--<td>{{ student.id }}</td>-->
                <td>
                  <router-link
                    :to="{ name: 'AffiliatePerformancePlanWise', params: { referrer_id: student.referrer.id } }"
                               class="link-muted"
                  > {{ student.referrer.username }}
                  </router-link>
                </td>
                <td>{{ student.referrer.name }}</td>
                <td>{{ student.ref_click_log_count }}</td>
                <td>{{ student.total_order_price | afterDecimal2 }}</td>
                <td>{{ student.total_earned_points | afterDecimal2 }}</td>
                <td>{{ student.ref_created_at | moment }}</td>
                <td>
                  <b-button v-b-modal.disburse-modal class="btn btn-danger"
                            @click="handleDisburseModalClick(student)">
                    <i class="fas fa-dollar-sign"></i>
                  </b-button>
                </td>
              </tr>
              </tbody>
            </table>

            <div class="p-4" v-if="_.isEmpty(students.data)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination
              :pagination="students"
              v-if="students.total > students.per_page"
              @paginate="init()"
            />
          </div>
        </div>
      </div>
    </section>

    <b-modal id="disburse-modal" ref="disburse-modal" title="Disburse Balance" @hidden="resetModal"
             @show="resetModal(true)" :no-close-on-esc=true :no-close-on-backdrop=true hide-footer>
      <form ref="form" @submit.stop.prevent="handleDisburseSubmission">
        <b-form-group label="Username" label-for="username-input" invalid-feedback="Username is required">
          <b-form-input v-model="disburse_username" name="disburse_username" id="username-input" type="text" disabled/>
          <!--<b-form-input v-model="disburse_user_id" id="username-input" type="text" disabled/>-->
          <div class="help text-danger" v-show="errors.has('disburse_username')">
            {{ errors.first("disburse_username") }}
          </div>
        </b-form-group>
        <b-form-group label="Balance" label-for="amount-input" invalid-feedback="Username is required">
          <b-form-input v-model="disburse_amount" name="disburse_amount"
                        id="amount-input" type="number" min="1" max="10000" required/>
          <small class="text-muted " v-if="disburse_wallet != null">
            Available balance is: {{ disburse_wallet }}
          </small>
          <div class="help text-danger" v-show="errors.has('disburse_amount')">
            {{ errors.first("disburse_amount") }}
          </div>
        </b-form-group>
        <b-form-group label="Description" label-for="description-input" invalid-feedback="Description is required">
          <b-form-textarea v-model="disburse_description" name="disburse_description" id="description-input"
                           placeholder="Enter something..."
                           rows="3" max-rows="6"/>
          <div class="help text-danger" v-show="errors.has('disburse_description')">
            {{ errors.first("disburse_description") }}
          </div>
        </b-form-group>
        <b-form-group label="Attachment" label-for="document-input" invalid-feedback="Attachment is required">
          <b-form-file v-model="disburse_attachments" name="disburse_attachments"
                       placeholder="Choose a file or drop it here..."
                       drop-placeholder="Drop file here..." class="inf" variant="dark"
                       accept=".zip, .docx,.doc,.pdf"
                       @change="disburseAttachment($event, 'disburse_attachments')"/>
          <div class="help text-danger" v-show="errors.has('disburse_attachments')">
            {{ errors.first("disburse_attachments") }}
          </div>
        </b-form-group>
        <b-form-group>
          <b-button type="submit" class="mt-3 btn-info" block :disabled="is_loading">Submit</b-button>
        </b-form-group>
      </form>
    </b-modal>

  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent"
import {LearningReportApi} from "@/services/api"
import SortIcons from "@/components/utils/SortIcons"

import DatePicker from "vue2-datepicker"
import "vue2-datepicker/index.css"
import axios from "axios"
import fileDownload from "js-file-download"

export default {
  name: "AffiliatePerformance",
  metaInfo: {
    title: "Affiliate performance | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons
  },
  data: () => ({
    students: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    show_filter: false,
    filter: {},
    disburse_wallet: null,
    disburse_username: null,
    disburse_user_id: null,
    disburse_amount: null,
    disburse_description: null,
    disburse_attachments: null,
    disburse_attachments_name: null,
    is_loading: false,
  }),
  methods: {
    init() {
      this.filter = JSON.parse(JSON.stringify(this.$route.query))
      if (!_.isEmpty(this.filter)) this.show_filter = true
      this.is_loading = true
      let params = {...this.filter, ...this.$route.query}
      LearningReportApi.affiliatePerformance(params)
        .then((students) => {
          this.students = students
        })
        .finally(() => {
          this.is_loading = false
        })
    },
    resetFilter() {
      this.$router.push({path: this.$route.path}).catch(() => {
      })
    },
    async getFilterData() {
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.filter,
        })
        .catch((err) => {
          console.log(err)
        })
    },
    exportReport: function () {
      this.is_loading = true
      axios
        .get("/reports/affiliate/performance-export", {
          params: this.filter,
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "affiliate-performance.xlsx")
        })
        .catch((error) => {
          console.log("error " + error)
        })
        .finally(() => {
          this.is_loading = false
        })
    },
    handleDisburseModalClick(data) {
      this.disburse_username = data.referrer.username
      this.disburse_user_id = data.referrer.id
    },
    async resetModal(show_wallet = false) {
      if (show_wallet === true) {
        await axios.get('/auth/wallet-point?user_id=' + this.disburse_user_id)
          .then(response => {
            this.disburse_wallet = response.data.points
          }).catch(error => {
            throw(error.response)
          })
      } else {
        this.disburse_wallet = null
      }
      this.disburse_amount = null
      this.disburse_description = null
      this.disburse_attachments = null
    },
    handleDisburseModalOk(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.handleDisburseSubmission()
    },
    disburseAttachment: function (event, filename = "file_path") {
      try {
        let _this = this
        _this.is_loading = true
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
          _this.disburse_attachments = reader.result
          _this.disburse_attachments_name = event.target.files[0].name
          _this.is_loading = false
        };
      } catch (e) {
        console.log(e)
      }
    },
    handleDisburseSubmission() {
      this.is_loading = true
      let api_url = '/wallet/disbursement'
      axios.post(api_url, {
        disburse_user_id: this.disburse_user_id,
        disburse_amount: this.disburse_amount,
        disburse_description: this.disburse_description,
        disburse_attachments: this.disburse_attachments
      }).then(response => {
        this.$toaster.success(response.data.message)
        this.$nextTick(() => {
          this.$bvModal.hide('disburse-modal')
        })
      }).catch(error => {
        this.$toaster.error(error.response.data.message)
        this.$setErrorsFromResponse(error.response.data)
      }).finally(() => {
        this.is_loading = false
      })
    }
  },
  mounted() {
    this.init()
    this.$root.$on('sort-data', () => {
      this.$root.$emit('show-icon')
    })
  },
  watch: {
    '$route.query'() {
      this.init()
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a")
    },
    afterDecimal2(data) {
      return parseFloat(data).toFixed(2)
    }
  },
};
</script>
